import type { FunctionComponent } from 'react';
import type { MessageFormatterReturnType } from '@/domains/core/localization/translate';
import { twMerge } from '@/domains/core/tamagoshiTailwind/util/twMerge';
interface TitleProps {
  className?: string;
  label: string;
  link?: MessageFormatterReturnType;
}
export const Title: FunctionComponent<TitleProps> = ({
  className,
  link,
  label
}) => {
  return <div className={twMerge('flex h-[28px] w-full items-center justify-between px-xs desktop:p-0', className)}>
      <span className="font-bold text-foundation-primary">{label}</span>
      {link}
    </div>;
};
Title.displayName = 'Title';